import React from 'react'

const CssSVG = () => {
  return (
    <svg width="63" height="64" viewBox="0 0 63 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="31.5" cy="32.25" r="31.5" fill="#E2F3FF"/>
      <g clipPath="url(#clip0_0_1)">
      <path d="M16.5469 14.2501H48.7031L45.7784 46.5946L32.5898 50.2501L19.4746 46.5931L16.5469 14.2501ZM42.7159 20.8696L22.5341 20.8651L22.8602 24.7981L38.3641 24.8011L37.9737 28.8751H27.8062L28.1737 32.7346H37.6398L37.0794 38.0191L32.6235 39.2251L28.0971 38.0101L27.8092 34.8451H23.8127L24.2567 40.6276L32.625 43.1821L40.8524 40.8871L42.7159 20.8711V20.8696Z" fill="#1572B6"/>
      </g>
      <defs>
      <clipPath id="clip0_0_1">
      <rect width="36.75" height="36" fill="white" transform="translate(14.25 14.2501)"/>
      </clipPath>
      </defs>
    </svg>
  )
}

export default CssSVG